
import { Component, Vue } from 'vue-property-decorator';
import AppFooter from '@/components/Layout/AppFooter.vue';
import setThemeVariables from '~/helpers/BrandThemeHelper';
import api from '~/api/client';

@Component({ components: { AppFooter } })
export default class App extends Vue {
  get configLoaded(): boolean {
    return this.$store.getters['Config/isConfigLoaded'];
  }

  async created() {
    setThemeVariables();

    const data = this.$store.getters['Config/getAxiosConfig'];
    api.updateConfig(data);
    const brandingData = await this.$store.dispatch('Config/getBrandingData');
    const brandName = brandingData.brand_name;
    const brand = brandName ? brandName.toLowerCase().replaceAll(' ', '') : 'momnt';

    [192, 96, 32, 16].forEach((size: number) => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'icon');
      if (size) link.setAttribute('sizes', `${size}x${size}`);
      link.setAttribute('href', `/img/${brand}-${size || '16'}.png`);
      document.head.appendChild(link);
    });
  }
}
